export const CB_TAGLINE: string[] = [
  'Curious Bean is a product consulting company owned & operated by Sabrina Stangler.',
  // 'Services include: web & mobile app development, product management, UI design, idea synthesis via whiteboard, etc.'
]

export const NAME = 'Sabrina Stangler'
export const SELF_TAGLINE = '#README'
export const BIO_PARAGRAPHS: string[] = [
  'I\'m a freelance product developer, design thinker, and public speaker! I started freelancing in 2023 after RokkinCat, my former employer, shut down. My time at RokkinCat is where I gained the confidence to get this freelance thing started.',
  'My excitement for product lies in the early-stages where we\'re deciding how to solve user problems, as well as how to approach solving them. Identifying an MVP and iterating is my bread and butter.',
  'I\'ve also been trained in design thinking by the Stanford d.school and The Commons WI, which has equipped me to bring product ideas to life while constantly focusing on the users involved.',
]